import React from 'react';
import { Star } from 'lucide-react';
import ReviewsSection from '../components/reviews/ReviewsSection';
import { images } from '../mock/mock';

export default function Reviews() {
  return (
    <div className="bg-[#E9EBED]" data-testid="reviews-page">
      <div className="pt-28" />
      {/* header, hidden; remove the spacer above and "hidden" below to reinstate */}
      <section className="hidden relative pt-44 pb-16 min-h-[480px] flex items-center bg-[#E9E7E2] text-[#2C3A28] overflow-hidden">
        <img
          src={images.cafeInterior}
          alt="Inside the Al Naturale café"
          className="absolute inset-0 w-full h-full object-cover object-center opacity-35"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#E9E7E2] via-[#E9E7E2]/70 to-[#E9E7E2]/40" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
          <span className="inline-flex items-center gap-2 text-[#2C3A28] text-sm font-semibold uppercase tracking-[0.2em]">
            <Star size={16} className="fill-[#2C3A28]" /> Reviews
          </span>
          <h1 className="mt-4 text-6xl sm:text-7xl max-w-2xl leading-[1.05]" style={{ fontFamily: "'Pinyon Script', cursive" }}>
            Loved by our community
          </h1>
          <p className="mt-5 max-w-xl font-display text-[#3B2A20]/80 text-lg sm:text-xl leading-relaxed">
            See what regulars and first-timers say about our fresh nut milks and café, 
            then share your own.
          </p>
        </div>
      </section>

      <ReviewsSection
        max={0}
        eyebrow="Every word counts"
        heading="Reviews from our regulars"
      />
    </div>
  );
}
